import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareZoomAiCompanionCopy } from "../lib/translations/pages/compare-zoom-ai-companion";

export function CompareZoomAiCompanion() {
  const lang = useLang();
  return <ComparePage copy={compareZoomAiCompanionCopy[lang]} path="/compare/zoom-ai-companion-vs-minuta" />;
}
